import { render, staticRenderFns } from "./NavPopup.vue?vue&type=template&id=5ed02909&scoped=true&"
import script from "./NavPopup.vue?vue&type=script&lang=js&"
export * from "./NavPopup.vue?vue&type=script&lang=js&"
import style0 from "./NavPopup.vue?vue&type=style&index=0&id=5ed02909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed02909",
  null
  
)

export default component.exports